import { useIsFocused } from '@react-navigation/native';
import React from 'react';
import { ScrollView } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { VehicleGalleryProps } from 'src/common/api/response';
import { useTripGalleryInfiniteQuery } from 'src/common/hooks';
import { isCloseToBottom } from 'src/common/utils/KeyExtractor';
import { EmptyState, Row } from 'src/components';
import CustomFastImage from 'src/components/bases/CustomFastImage';
import { device, metrics } from 'src/themes/Metrics';
import { ImageViewerModal } from '../ImageViewerModal';

const imageSmallWidth = device.width / 3.48;
const imageMediumWidth = device.width / 2.25;
// const images = [
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
//   { image: faker.image.imageUrl(640, 480, 'place', true), alt: '' },
// ] as VehicleGalleryProps[];

let counter = -1;

export const GalleryContent = ({ tripId }: { tripId: string }) => {
  // const [isViewerOpen, setIsViewerOpen] = React.useState(false);
  const {
    data: galleryData,
    isLoading: galleryIsLoading,
    isFetching: galleryFetching,
    // isFetchingNextPage: galleryIsFetchingNextPage,
    fetchNextPage: galleryFetchNextPage,
    hasNextPage: galleryHasNextPage,
    refetch: galleryRefetch,
    error: galleryError,
    isError: galleryIsError,
  } = useTripGalleryInfiniteQuery({ tripId });
  const focus = useIsFocused();
  const [previewIndex, setPreviewIndex] = React.useState<number>(-1);

  console.log({ tripId });
  const handleFetchMore = () => {
    if (galleryHasNextPage && !galleryFetching) {
      galleryFetchNextPage();
    }
  };

  React.useEffect(() => {
    if (!tripId) return;
    galleryRefetch();
  }, [focus, tripId]);

  const galleryImages = React.useMemo(() => {
    if (galleryData?.pages) {
      return galleryData.pages.map(p => p.data.data).flat();
    }

    return [];
  }, [galleryData]);

  React.useEffect(() => {
    counter = -1;
  });

  const renderItem = (item: VehicleGalleryProps, index: number) => {
    counter += 1;
    if (is3Row(counter)) {
      return (
        <TouchableOpacity
          key={index.toString()}
          activeOpacity={0.8}
          onPress={() => {
            setPreviewIndex(index);
          }}>
          <CustomFastImage
            style={{ borderRadius: metrics.borderRadius, marginBottom: metrics.medium }}
            width={imageSmallWidth}
            height={imageSmallWidth}
            source={{ uri: item.image }}
            resizeMode="cover"
          />
        </TouchableOpacity>
      );
    }
    return (
      <TouchableOpacity key={index.toString()} activeOpacity={0.8} onPress={() => {}}>
        <CustomFastImage
          style={{ borderRadius: metrics.borderRadius, marginBottom: metrics.medium }}
          width={imageMediumWidth}
          height={imageSmallWidth}
          source={{ uri: item.image }}
          resizeMode="cover"
        />
      </TouchableOpacity>
    );
  };

  const is3Row = (index: number): boolean => {
    if (index < 3) return true;
    if (index < 5) return false;
    counter = 0;
    return is3Row(counter);
  };

  if (galleryIsLoading || galleryIsError) {
    return <EmptyState loading={galleryIsLoading} error={galleryError} text="tripEmptyContent" />;
  }

  return (
    <ScrollView
      contentContainerStyle={{ padding: metrics.large }}
      onScroll={({ nativeEvent }) => {
        if (isCloseToBottom(nativeEvent)) {
          handleFetchMore();
        }
      }}
      scrollEventThrottle={16}>
      {/* <Row style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>{galleries.map(renderItem)}</Row> */}
      <Row style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>{galleryImages.map(renderItem)}</Row>
      {/* <ImgsViewer
        imgs={galleries.map(g => ({ src: g.image }))}
        // currImg={currImg}
        isOpen={isViewerOpen}
        onClickPrev={() => {}}
        onClickNext={() => {}}
        onClose={() => setIsViewerOpen(false)}
      /> */}
      <ImageViewerModal
        isVisible={previewIndex !== -1}
        index={previewIndex}
        onClose={() => {
          setPreviewIndex(-1);
        }}
        images={galleryImages.map(image => ({ url: image.image }))}
      />
    </ScrollView>
  );
};
